import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Questionnaire from '../../../Questionnaire/Questionnaire';
import MyAccountContentHeader from '../MyAccountContentHeader/MyAccountContentHeader';
import './MyAccountQuestionnaireDefaults.css';
import * as http from '../../../../utils/http';
import * as translator from '../../../../utils/translator';

const MyAccountQuestionnaire = () => {
	const { setActiveMenuLinkId, setStickyNotificationDetails, locale, country, language, setLoading, setError } = useOutletContext<any>();

	const [questionnaireDefaults, setQuestionnaireDefaults] = useState<any>(null);

	useEffect(() => {
		setActiveMenuLinkId('questionnaire-defaults');

		setLoading(true);

		http
			.getFromServer(`${country}/account/questionnaire-defaults`, [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.CART_ORDER])
			.then((response) => {
				setQuestionnaireDefaults(response.data);
				window.scrollTo(0, 0);
			})
			.catch((error) => {
				window.clientLogger.error('Error in MyAccountQuestionnaireDefaults: ', error);
				setError(500);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);

	const onSubmitOverride = async (wasRefilled: boolean, bundledQuestionnaireForSending: any[], files: Array<any>) => {
		http
			.postMultiPartsToServer(
				`account-update/questionnaire-defaults`,
				{
					questionnaire: bundledQuestionnaireForSending,
					localeID: locale?.language_id?.toLowerCase() + '-' + locale?.country_id?.toUpperCase(),
				},
				files,
				[http.MIDDLEWARES.CUSTOMER_ID]
			)
			.then((res) => {
				setStickyNotificationDetails((currentDetails: any) => ({
					show: true,
					title: '',
					content: 'Patient record updated successfully.',
					level: res.data.message,
					showInfoIcon: false,
				}));
			})
			.catch((err) => {
				window.clientLogger.error('error submit my account questionnaire', err);
			})
			.finally(() => {});
	};

  if (!questionnaireDefaults) {
    return <></>;
  }

	return (
		<>
			<div className="account-content">
				<MyAccountContentHeader
					title={translator.translate(language, 'my_account', 'QuestionnaireDefaultSettings/title')}
					description={translator.translate(language, 'my_account', 'QuestionnaireDefaultSettings/subTitle')}
				/>
				<div className="questionnaire-defaults-container">
					<Questionnaire
						submitButtonText={translator.translate(language, 'my_account', 'QuestionnaireDefaultSettings/submit_button_text')}
						myAccountQuestionnaireDefaults={questionnaireDefaults}
						onSubmitOverride={onSubmitOverride}
						prefilledQuestionnaire={questionnaireDefaults?.prefilledQuestionnaire}
					/>
				</div>
			</div>
		</>
	);
};

export default MyAccountQuestionnaire;
